import { Card } from '@avanta/shared/components/ui/Card';
import { LOCIZE_NS } from '@avanta/shared/constants/common';
import { Activity } from 'react';
import { useTranslation } from 'react-i18next';
import { CodeVerification, EmailForm, PasswordChange } from './components';
import { useRecoverPassword } from './useRecoverPassword';

const steps = [
  { id: 1, title: 'RecoverPassword.heading' },
  { id: 2, title: 'RecoverPassword.Verification.heading' },
  { id: 3, title: 'RecoverPassword.PasswordChange.heading' },
];

export const RecoverPassword = (): React.ReactElement => {
  const { t } = useTranslation(LOCIZE_NS.AUTH);
  const {
    recoverPassword,
    verifyCode,
    resendCode,
    changePassword,
    error,
    isLoading,
    currentStep,
    userEmail,
  } = useRecoverPassword();

  return (
    <div className="flex items-center justify-center bg-gray-50 max-am-xl:mt-24 am-xl:h-screen am-xl:p-24">
      <Card className="w-full bg-white rounded-2xl shadow-md max-w-70 p-5 am-sm:max-w-80 am-md:max-w-87.5 am-xl:p-10 am-xl:max-w-96">
        <div className="flex flex-col items-center justify-center">
          <h2 className="text-2xl font-bold text-center mb-6 max-w-67.5">
            {t(steps[currentStep - 1].title)}
          </h2>
          <Activity mode={currentStep === 1 ? 'visible' : 'hidden'}>
            <EmailForm onSubmit={recoverPassword} error={error} isLoading={isLoading} />
          </Activity>
          <Activity mode={currentStep === 2 ? 'visible' : 'hidden'}>
            <CodeVerification
              onVerifyCode={verifyCode}
              onResendCode={resendCode}
              error={error}
              isLoading={isLoading}
            />
          </Activity>
          <Activity mode={currentStep === 3 ? 'visible' : 'hidden'}>
            <PasswordChange
              onSubmit={changePassword}
              error={error}
              isLoading={isLoading}
              userEmail={userEmail}
            />
          </Activity>
        </div>
      </Card>
    </div>
  );
};
